export enum ErrorCodes {
  SupportedCountryRequired = 601,
  ValidTaxableAddressRequired = 602,
  ValidPaymentMethodRequired = 603,
  EmailClaimFailedToDeliverCode = 701,
  EmailClaimTooManyAttemptsToSendCode = 702,
  EmailClaimTooManyAttemptsToVerifyCode = 703,
  EmailClaimInvalidCode = 704,
  EmailClaimInvalidEmail = 705,
  LoginCodeExpired = 901,
  LoginCodeDeviceTypeMismatch = 10352,

  // Messaging Service Errors
  TextSummarizationContentFilter = 301,
  TextSummarizationNoContent = 30303,
  // Add-on related (1161-1170)
  CellularAddonPurchaseFailedWithSavedPayment = 1161,
  CellularSimNotFound = 1144,
  CellularPortInFailedToUpdate = 1173,
  GigsAddressValidationFailed = 2002,
  CellularPortInNotSupported = 1178,
  E911DeviceNotFound = 11305,
}
